@forward '@raspberrypifoundation/design-system-core/scss/components/button';
@forward '../../global/styles';

:host {
  --menu-button-icon-color: var(--rpf-text-primary);
  --menu-heading-border-color: var(--rpf-grey-150);
  --menu-item-hover-background-color: var(--rpf-grey-50);
  --menu-item-active-background-color: var(--rpf-grey-100);
  --menu-item-text-color: var(--text-color);
  --menu-item-tick-color: var(--rpf-text-primary);
  --menu-focus-border-color: var(--focus-border-color);

  display: block;
}

:host([theme='dark']) {
  --menu-button-icon-color: var(--rpf-white);
  --menu-heading-border-color: var(--rpf-grey-600);
  --menu-item-hover-background-color: var(--rpf-grey-700);
  --menu-item-focus-border-color: var(--rpf-brand-raspberry);
  --menu-item-active-background-color: var(--rpf-grey-600);
  --menu-item-text-color: var(--text-color);
  --menu-item-tick-color: var(--rpf-white);
  --menu-focus-border-color: var(--focus-border-color);
}

:host([theme='clear']) {
  --menu-button-icon-color: var(--rpf-white);
  --menu-heading-border-color: var(--rpf-grey-600);
  --menu-item-hover-background-color: var(--rpf-grey-50);
  --menu-item-active-background-color: var(--rpf-grey-100);
  --menu-item-text-color: var(--rpf-text-secondary);
  --menu-item-tick-color: var(--rpf-text-secondary);
  --menu-focus-border-color: var(--rpf-brand-raspberry);
}

.rpf-language-picker__button {
  align-items: center;
  block-size: 1.25rem;
  display: flex;
  gap: 0.3rem;

  svg {
    path {
      fill: var(--menu-button-icon-color);
    }
  }

  &-text {
    display: none;
    font-family: var(--font-family);
    font-size: var(--font-size-1);
    font-weight: var(--font-weight-bold);

    @container (min-width: 22.5rem) {
      display: block;
    }
  }
}

.rpf-language-picker__menu {
  display: flex;
  flex-direction: column;
  inline-size: 100%;
  padding-block-start: var(--space-0-5);
  padding-inline: var(--space-1-5);
}

h2 {
  block-size: 2.625rem;
  border-block-end: var(--border-width-sm) solid var(--menu-heading-border-color);
  box-sizing: border-box;
  font-size: var(--font-size-1);
  font-weight: var(--font-weight-bold);
  margin-block: 0;
  padding-block: 0.375rem;
  text-align: center;
}

ul {
  box-sizing: border-box;
  color: var(--rpf-text-secondary);
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
  list-style: none;
  margin: 0;
  overflow-y: auto;
  padding: 0;
  padding-block: var(--space-1);
  padding-inline-end: var(--space-1);
  scrollbar-color: var(--rpf-grey-400) transparent;
  scrollbar-gutter: stable;
}

a {
  border-color: transparent;
  border-radius: var(--border-radius);
  border-style: solid;
  border-width: var(--border-width-md);
  box-sizing: border-box;
  color: var(--menu-item-text-color);
  display: block;
  font-size: var(--font-size-1);
  padding-block: var(--space-1-5);
  padding-inline: var(--space-2);
  text-decoration: none;
  word-wrap: break-word;

  &:hover {
    background-color: var(--menu-item-hover-background-color);
  }

  &:active {
    background-color: var(--menu-item-active-background-color);
  }

  &:focus-visible {
    background-color: transparent;
    border-color: var(--menu-focus-border-color);
    outline-style: none;
  }

  &.selected {
    background-color: var(--menu-item-active-background-color);

    svg {
      margin-inline-end: var(--space-1);

      path {
        fill: var(--menu-item-tick-color);
      }
    }
  }
}
